<!DOCTYPE html>
@if (cardLoaded) {
  <div class="game-popup">
    <div mat-dialog-actions align="end">
      <button mat-button (click)="closeDialog()" class="cross-btn"><img src="assets/images/cross-img.png" /></button>
    </div>
    <ion-card>
      <!-- This is a container for displaying an error toast message -->
      @if (show) {
        <div class="toast-error">
          <!-- This is a row element within the toast container -->
          <ion-row class="border-bottom">
            <ion-col size="2" class="ion-margin-top ion-text-center" (click)="dialogClose()">
              <img src="../../../assets/icon/tick circle error.svg" alt="toast-row-fail" />
            </ion-col>
            <ion-col size="10">
              <!-- This is a paragraph element with a class for styling, containing the error message -->
              <p class="toast-msg">
                {{'game_preview_popup.error_message' | translate}}
                <!-- This is a nested span element, providing additional details about the error -->
                <span>{{'game_preview_popup.reason' | translate}} {{reason}}</span>
              </p>
            </ion-col>
          </ion-row>
        </div>
      }
      <img class="game-preview-image" alt="Silhouette of mountains" [src]="gamePreviewData?.game_popup_image_url" />
      <ion-card-header class="ion-no-padding ion-flex-column">
        @if (gamePreviewData?.category !== 'Prize Unlocker') {
          <div class="prize-tag-cover">
            <span
              class="preview-price-tag bg-{{ gamePreviewData?.tier }}"
              [ngClass]="prizeUnlockID == gameInfo$?.game_id && gameInfo$?.total_reward ? 'pop-price-span' : ''"
              >{{
              prizeUnlockID == gameInfo$?.game_id && gameInfo$?.total_reward
              ? gamePreviewData?.country_code_data[
              preferredCurrency == "CAD" ? 1 : preferredCurrency == "EUR" ? 353 : 44
              ]?.game_title.replace(
              "[prize_number]",
              gameInfo$?.play_count + (gameInfo$?.play_count > 1 ?  (('game_preview_popup.prizes' | translate) ? ('game_preview_popup.prizes' | translate) : 'Prizes') :  (('game_preview_popup.prize' | translate) ? ('game_preview_popup.prize' | translate) : 'Prize')))
              : gamePreviewData?.top_prize
              }}
              @if (gamePreviewData?.game_id && gamesWithNoPrize?.includes(gamePreviewData?.game_id)) {
                <div>
                  <img src="assets/images/star.svg" class="money-bag-img" />
                </div>
              }
            </span>
          </div>
        }
        <ion-card-title class="card-title">{{
          prizeUnlockID == gameInfo$?.game_id && gameInfo$?.total_reward ? "" : (('game_preview_popup.top_prize' | translate) ? ('game_preview_popup.top_prize' | translate) : 'Top Prize')
        }}</ion-card-title>
        <!-- <ion-card-subtitle class="sub-card-title">{{ gamePreviewData?.game_popup_details }}</ion-card-subtitle> -->
        <ion-card-subtitle class="sub-card-title">{{ popupDetails }}</ion-card-subtitle>
        @if (prizeUnlockID == gameInfo$?.game_id && gameInfo$?.total_reward) {
          <p class="prize_unlock_details">
            <span>{{('game_preview_popup.points' | translate) ? ('game_preview_popup.points' | translate) : 'Points'}} <br />{{ gameInfo$?.total_reward }}</span
              ><span>{{('game_preview_popup.credit' | translate) ? ('game_preview_popup.credit' | translate) : 'Credit'}}<br />{{ gameInfo$?.total_credit }}</span
              ><span>{{('game_preview_popup.cash' | translate) ? ('game_preview_popup.cash' | translate) : 'Cash'}}<br />{{ gameInfo$?.total_cash }}</span>
            </p>
          }
        </ion-card-header>
        <ion-card-content>
          @if (showPremiumToggle) {
              <div class="ion-text-center">
                <ion-toggle class="custom-toggle" #premiumToggle [checked]="gamePreviewData?.is_premium_game"
                  (ionChange)="onToggleChange($event)"></ion-toggle>
              </div>
              <p class="ion-text-center ion-padding-bottom">{{('game_preview_popup.jackpot_boost' | translate)}}</p>
          }
          <ion-button expand="block" color="secondary" class="game-preview-btn" type="submit" (click)="playGame()">
            {{gamePreviewData?.category == 'Prize Box' ? ('game_preview_popup.buy_now' | translate ) :
            ('game_preview_popup.play_now' | translate)}}
            @if ((!isY2pPopup || gamePreviewData?.is_premium_game) && gamePreviewData?.category !== 'Prize Box' && gamePreviewData?.game_price > 0) {
              <img
                class="pointcoing" src="assets/images/pointIcon.png" alt="pointIcon" />
            }
            @if (gamePreviewData?.category === 'Prize Box') {
              <img class="GiftIcon"
                src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/icons%2Fprize_box_token.svg?alt=media&token=0a24a01c-770f-47b0-a811-a168bba33cfe"
                alt="GiftIcon" />
            }
            @if ((!isY2pPopup || gamePreviewData?.is_premium_game) && gamePreviewData?.category !== 'Prize Unlocker' && gamePreviewData?.game_price > 0) {
              <span
              [ngClass]="salesCost && flashSaleEnabled ? 'discounted-price' : 'pop-price-span'">{{ (salesCost && flashSaleEnabled) ? gamePreviewData?.game_price : '- ' + gamePreviewData?.game_price }}</span>
            }
            @if (salesCost && flashSaleEnabled) {
              <strong >{{'-' + salesCost}}</strong>
            }
          </ion-button>
          @if (gamePreviewData?.category !== 'Prize Unlocker') {
            <div class="preview-learn-more"
              (click)="goToGameDetails(gamePreviewData?.game_type_id, gamePreviewData?.game_id, gamePreviewData?.category, { sales_cost : salesCost })">
              {{('game_preview_popup.learn_more' | translate) ? ('game_preview_popup.learn_more' | translate) : 'Learn more'}}
            </div>
          }
        </ion-card-content>
      </ion-card>
    </div>
  } @else {
    <mat-spinner class="popup-loader"></mat-spinner>
  }

